import React, { useState, useEffect } from 'react'
import Loading from './Loading'
import Tours from './Tours'
// ATTENTION!!!!!!!!!!
// I SWITCHED TO PERMANENT DOMAIN
const url = 'https://course-api.com/react-tours-project'
function App() {
  const [loading, setLoading]=useState(true);
  const [tours,setTours]=useState([]);
  
  const removeTour = (id) => {
    const newtours = tours.filter((tour) => tour.id !== id);
    setTours(newtours);
  };

  const fetchTours= async (removeTour) => {
    setLoading(true);
    try {
       const response = await fetch(url);
        const tours = await response.json();
        setTours(tours);
        setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
   
  
  };
useEffect(() => {
fetchTours();
},[]);

if(loading)
  return (<main>
    <Loading/>
    </main>);
else
  return (
    <main>
      <Tours tours={tours} removeTour={removeTour}/>
    </main>
  );
}

export default App
